export const TagPill = ({ text }: { text: string }) => (
  <div className="border rounded px-1 bg-muted text-muted-foreground w-fit inline-block text-sm">
    {text}
  </div>
);
